import React from "react";
import Helmet from "react-helmet";
import { navigateTo } from "gatsby-link";
import CallToAction from "../components/CallToAction";
import Jumbotron from "../components/Jumbotron";
import FeaturedHalfs from "../components/FeaturedHalfs";
// import ResearchAreas from "../components/ResearchAreas";
import SubNav from "../components/sub-nav";
import { Element, scroller } from "react-scroll";
import styles from "../styles/about-us.module.scss";
import PageWrapper from "../components/PageWrapper";

// TODO: Fix the dropdown navigation for spotlight/research areas. How to do it without forcing complete refresh of the page?

class ResearchSpotlight extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			featured: 1,
			currentCat: "spotlight",
			loadMore: false
		};
	}
	shouldComponentUpdate(nextProps, nextState) {
		// const { props } = this;
		// const { location } = nextProps;

		// if (nextState.currentCat !== this.state.currentCat) {
		// 	return true;
		// }
		// return (
		// 	location.pathname !== props.location.pathname ||
		// 	location.hash !== props.location.hash
		// );
	}

	componentWillReceiveProps(nextProps) {
		// const oldHashCategory = this.props.location.hash.slice(1);
		// const newHashCategory = nextProps.location.hash.slice(1);

		// if (oldHashCategory !== newHashCategory && newHashCategory.length > 0) {
		// 	this.setState({ currentCat: newHashCategory });
		// }
	}

	componentDidMount() {
		const hashCategory = this.props.location.hash.slice(1);

		// if (hashCategory.length > 0) {
		// 	this.setState({ currentCat: hashCategory });
		// }

		scroller.scrollTo(hashCategory, {
			duration: 500,
			delay: 50,
			smooth: true,
			offset: -100 // Scrolls to element + 50 pixels down the page
		});
	}

	handleClick = () => {
		this.setState({ featured: 2, loadMore: false });
	};

	handleSubNavClick = category => {
		const locale = this.props.data.contentfulResearchPage.node_locale;
		navigateTo({ pathname: `/${locale}/research`, hash: category });
	};

	render() {
		const { transition, data } = this.props;
		const researchSpotlightList = data.researchSpotlight.edges;
		const hasMorePages = data.researchSpotlight.pageInfo.hasNextPage;
		const pageSettings = data.contentfulResearchPage;
		const cta = data.cta.edges[0].node;

		const navList = [
			{
				label: "Research Spotlight",
				name: "spotlight",
				href: "research"
			},
			{
				label: "Research Areas",
				name: "areas",
				href: "research-areas"
			}
		];

		return (
			<PageWrapper locale={pageSettings.node_locale} location={this.props.location} data={data.layout.edges[0].node}>
				<main role="main" style={transition && transition.style}>
					<Helmet title={pageSettings.pageTitle  + " | Mahidol Vivax Research Unit"} />
					<Element name={"spotlight"} className="element">
						<Jumbotron
							type="jumbotron_b"
							bottomLine={true}
							className="mb-0"
							textAlign="text-center"
							contentAlign="justify-content-md-center"
						>
							<h1 className={styles.jumbo_h1}>{pageSettings.pageTitle}</h1>
						</Jumbotron>
					</Element>
					<div className={"grey_bg "} style={{ position: "relative" }}>
						<div
							className="container"
							style={{ transform: "translateY(-50%)" }}
						>
							<div className="row justify-content-center">
								<div className="col-12 col-lg-10">
									<SubNav
										active={"spotlight"}
										scroll={false}
										noHash={true}
										navList={navList}
										locale={pageSettings.node_locale}
										handleClick={this.handleSubNavClick}
									/>
								</div>
							</div>
						</div>
					</div>
	
					<div>
						<div>
							<FeaturedHalfs
								articles={researchSpotlightList}
							
							/>
	
							{/* <div className="grey_bg">
							<FeaturedQuarters
								className={"container py-3"}
								articles={quarterArticles}
							/>
						</div> */}
						</div>
	
						{hasMorePages && (
							<div className="grey_bg py-4 pb-5">
								<div className="container">
									<div className="row">
										<div className="col-12 text-center">
											<button
												role="button"
												className="button"
												onClick={() => this.handleClick()}
											>
												Load More
											</button>
										</div>
									</div>
								</div>
							</div>
						)}
	
						<div className="p-lg-3" >
							<CallToAction
								className="my-5"
								text={cta.content.childMarkdownRemark.html}
								buttonLabel={cta.buttonLabel}
								destination={`/${pageSettings.node_locale}${
									cta.linkTo
								}`}
								arrow={true}
							/>
						</div>
					</div>
	
					
				</main>
			</PageWrapper>
		);
	}
}

export default ResearchSpotlight;

export const query = graphql`
	query ResearchPageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		contentfulResearchPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		researchSpotlight: allContentfulResearchSpotlightStory(
			filter: { node_locale: { eq: $locale } }
			limit: 8
			sort: { order: DESC, fields: [datePublished] }
		) {
			pageInfo {
				hasNextPage
			}
			edges {
				node {
					node_locale
					title
					slug
					datePublished(formatString: "Do MMMM, YYYY")
					featuredImage {
						title
						sizes(maxWidth: 600, quality: 85) {
							src
						}
					}
					researchArea {
						title
					}
					content {
						childMarkdownRemark {
							excerpt(pruneLength: 160)
						}
					}
				}
			}
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "researchSpotlight" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/research-template.js